<template>
    <div class="overlay">
        <i id="loadingIcon" class="fa fa-spinner fa-spin reloader" aria-hidden="true"></i>
    </div>
</template>

<style scoped>
    .overlay {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>

<script>
export default {
	
}
</script>